<template>
    <div>
     
        <!-- 搜索筛选 -->
        <!-- 搜索筛选 -->
        <el-card class="box-card" style="margin-bottom: 20px;">
            <el-form :inline="true" class="user-search" :model="formInline" size="small">
                <el-form-item>
                    <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
                    <el-button size="small" type="danger" icon="el-icon-plus" @click="handleedit1">新增</el-button>
                 
                </el-form-item>
            </el-form>
        </el-card>
  
        <!--列表-->
        <!-- <el-tree
        :data="listData"
     
        node-key="id"
     
        :props="defaultProps"
        :expand-on-click-node="false"
      >
        <span class="custom-tree-node" slot-scope="{ data }">
          <span style="margin-right: 100px;width: 400px;">{{ data.remark }}</span>
          <span style="margin-right: 100px;width: 400px;">{{ data.interfaceName }}</span>
          <span style="margin-right: 100px;width: 400px;">
           
            <el-button
              type="text"
              size="mini"
              @click="handleedit(data)"
            >
               编辑
            </el-button>
            <el-button
            type="text"
            size="mini"
            @click="handledelete(data)">
                删除
          </el-button>
          </span>
        </span>
      </el-tree> -->
        <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border    row-key="id"
        :tree-props="{children: 'children', hasChildren: 'hasChildren'}"  element-loading-text="拼命加载中" style="width: 100%;">
            <el-table-column prop="id" label="id" width="100" align="center">
          </el-table-column>
          <el-table-column prop="interfaceName" label="地址接口" width="300" align="center">
            <template slot-scope="scope">
                {{scope.row.interfaceName?interfaceName:'---'}}
            </template>
          </el-table-column>
          <el-table-column prop="modal" label="接口分类" width="200" align="center">
          </el-table-column>
          <el-table-column prop="remark" label="接口名字" width="300" align="center">
          </el-table-column>
          <el-table-column align="center" label="操作" min-width="300">
              <template slot-scope="scope">
                  <el-button size="mini" type="primary" icon="el-icon-edit"
                      @click="handleedit( scope.row)">编辑</el-button>
                
                  <el-button size="mini" type="danger" icon="el-icon-delete"
                  @click="handledelete(scope.row)">删除</el-button>
             
              </template>
          </el-table-column>
        </el-table>
          <!-- 分页组件 -->
          <Pagination :child-msg="pageparm" @callFather="callFather"></Pagination>
        <!-- 弹框 设代理和设置会员-->
       <el-dialog
      :close-on-click-modal="false"
        title="设置"
        :visible.sync="dialogVisible"
        width="30%"
        >
        <el-form>
           
            
            <el-form-item label="地址接口" >
               <el-input v-model="editForm.interfaceName"></el-input>
               <!-- <el-input v-model="interfaceName"></el-input> -->
            </el-form-item>
            <el-form-item label="接口分类" >
                <!-- <el-input v-model="modal"></el-input> -->
                <el-input v-model="editForm.modal"></el-input>
             </el-form-item>
             <el-form-item label="remark" >
                <!-- <el-input v-model="remark"></el-input> -->
                <el-input v-model="editForm.remark"></el-input>
             </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="addEdit" >设置</el-button>
         
        </span>
      </el-dialog>
  
  
    </div>
  </template>
  
  <script>
    
  
    import {  authFunctionList ,addEditAuthFunction , delAuthFunction } from '../../api/pemission.js'
  
    import Pagination from '../../components/Pagination'
   
    // 导出模块
    export default {
        components: {
            Pagination,
          
           
        },
        // 模块数据
        data() {
            //数据  
            return {       
                loading: true,
                visible: false,
                listData: [],          
                dialogVisible: false,
                tagId:'',
                name:'',
                formInline: {
                    start: 0,
                    length: 5,
                   
                },
                 // 分页参数
                 pageparm: {
                      currentPage: 1,
                      pageSize: 10,
                      total: 10,
                      start: 0,
                      length: 10
                  },
                  interfaceName:'',
                    modal:'',
                    remark:'',
                  editForm:{  
                    interfaceName:'',
                    modal:'',
                    remark:''
                  }
            }
        },
  
  
        watch: {},
  
        methods: {
             // 查询
        //      search() {
        //       this.formInline.start = 0
				// this.pageparm.currentPage = 1
        //         this.getdata(this.formInline)
        //     },
          
            showPop(){
                this.visible = true
                console.log(111)
            },
            //获取所有操作权限
            getdata() {
              let param = this.formInline
              authFunctionList(param).then(res=>{
                this.saveParams(this.$route.path,this.formInline)
                    if (res.code == '200') {
                        this.listData = res.data
                       this.loading = false
                    }
                })
            },
            handleedit(row){
                this.dialogVisible = true
                this.editForm = Object.assign({}, row)
            },
            handleedit1(){
                this.dialogVisible = true  
                this.editForm = {}                         
            },
            addEdit(){
               
                let param = this.editForm
                
                addEditAuthFunction(param).then(res=>{
                  if(res.code==200){
                      this.$message({
                          type: "success",
                          message: '新增成功'
                      })      
                      this.getdata()
                      this.dialogVisible = false
                      this. editForm={  
                            interfaceName:'',
                            modal:'',
                            remark:''
                         }
                  }
                })
      
            },
            handledelete(row){
                let msg = '确定删除改菜单吗？'
              this.$confirm(msg, '提示', {
                      confirmButtonText: '确定',
                      cancelButtonText: '取消',
                      type: 'warning'
                  }).then(() => {
                    delAuthFunction(row).then(res=>{
                           
                      if(res.code==200){
                              this.$message({
                                  type: "success",
                                  message: '删除成功'
                                  })
                              this.getdata()
                            }
                       })
                  })
            },
           
           
        },
        // 创建前状态(里面是操作)
        beforeCreate() { },
        // 创建完毕状态(里面是操作)
        created() {
          this.getParams(this.$route.path)
            this.getdata()         
        },
        // 挂载前状态(里面是操作)
        beforeMount() { },
        // 挂载结束状态(里面是操作)
        mounted() { },
        // 更新前状态(里面是操作)
        beforeUpdate() { },
        // 更新完成状态(里面是操作)
        updated() { },
        // 销毁前状态(里面是操作)
        beforeDestroy() { },
        // 销毁完成状态(里面是操作)
        destroyed() { }
    };
  </script>
  
  <style scoped>
    .el-form-item {
        width: 40%;
        box-sizing: border-box;
    }
  
    .just-start {
        display: flex;
        justify-content: flex-start;
    }
  
    .marginT20 {
        margin-top: 20px;
    }
  </style>